export const MB_IN_BYTES = 1048576

export const ACCEPT_FILES = {
    img:'.jpg, .png, .jpeg',
    video: '.mp4',
    pdf:'.pdf',
    videoimg:'.jpg, .png, .jpeg, .mp4',
    ppt: '.ppt, .pptx',
    file: '*'
}